import { render, staticRenderFns } from "./TrackingBirthdayDiscount.vue?vue&type=template&id=eb6224d2&scoped=true"
import script from "./TrackingBirthdayDiscount.vue?vue&type=script&lang=ts"
export * from "./TrackingBirthdayDiscount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb6224d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb6224d2')) {
      api.createRecord('eb6224d2', component.options)
    } else {
      api.reload('eb6224d2', component.options)
    }
    module.hot.accept("./TrackingBirthdayDiscount.vue?vue&type=template&id=eb6224d2&scoped=true", function () {
      api.rerender('eb6224d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/components/TrackingBirthdayDiscount.vue"
export default component.exports